import React from 'react';
import { ApisauceInstance } from 'apisauce';

interface CloudFunctionClientContextType {
  api: ApisauceInstance;
}

const CloudFunctionClientContext =
  React.createContext<CloudFunctionClientContextType>({
    api: window.defaultApi,
  });

export default CloudFunctionClientContext;
